import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {concat, of, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomepageService {

  students$: any;
  studentsinput$ = new Subject<string>();

  constructor(private httpClient: HttpClient) {
  }

  postcustomizeWidgets(widget) {
    return this.httpClient.post('/dashboard/customizewidgets/', widget);
  }

  getcustomizeWidgets() {
    return this.httpClient.get('/dashboard/customizewidgets/');
  }

  getTeacherWidgets() {
    return this.httpClient.get(`/dashboard/get_teacherwidgets/`);
  }

  getSuperAdminWidgets() {
    return this.httpClient.get(`/dashboard/get_superadminwidgets/`);
  }

  getTotalUsers() {
    return this.httpClient.get(`/dashboard/get_SAtotal_no_users/`);
  }

  getAdminWidgets() {
    return this.httpClient.get(`/dashboard/get_adminwidgets/`);
  }

  getPrincipalWidgets() {
    return this.httpClient.get(`/dashboard/get_principalwidgets/`);
  }

  getComplaintsLastFive() {
    return this.httpClient.get('/dashboard/complaints_last_ten/');
  }

  getComplaintsAll() {
    return this.httpClient.get('/dashboard/complaints_all/');
  }

  getleaveapplications() {
    return this.httpClient.get(`/dashboard/get_leaveapplicationview/`);
  }

  getVicePrincipalWidgets() {
    return this.httpClient.get(`/dashboard/get_viceprincipalwidgets/`);
  }

  // Administrator Widgets
  getAdministratorWidgets() {
    return this.httpClient.get(`/dashboard/get_administratorwidgets/`);
  }

  getDueamount() {
    return this.httpClient.get(`/dashboard/get_dueamount/`);
  }

  getFailedTransaction() {
    return this.httpClient.get(`/dashboard/get_failedtransaction/`);
  }

  getSuccessfullTransaction() {
    return this.httpClient.get(`/dashboard/get_successfulltransaction/`);
  }

  getTodayFeeCollection() {
    return this.httpClient.get(`/dashboard/get_todayfeecollection/`);
  }

  getCpuMemoryUsage() {
    return this.httpClient.get('/dashboard/cpumemoryusage/');
  }

  getDiskUsage() {
    return this.httpClient.get('/dashboard/diskusage/');
  }

  // manager Widgets
  getManagerWidgets() {
    return this.httpClient.get(`/dashboard/get_managerwidgets/`);
  }

  getLibrarianWidgets() {
    return this.httpClient.get(`/dashboard/get_librarianwidgets/`);
  }

  getTotalBooks() {
    return this.httpClient.get(`/dashboard/get_totalbooks/`);
  }

  getDueBooks() {
    return this.httpClient.get(`/dashboard/get_duebooks/`);
  }

  // Parent WIDGETS
  getStudentWidgetsParent() {
    return this.httpClient.get(`/dashboard/get_studentwidgets_parent/`);
  }

  getFeeWidgetParent() {
    return this.httpClient.get('/dashboard/get_feewidget_parent/');
  }

  getGuagegraphWidgetParent() {
    return this.httpClient.get('/dashboard/get_guagegraphwidget_parent/');
  }

  // STUDENT WIDGETS
  getStudentWidgets() {
    return this.httpClient.get(`/dashboard/get_studentwidgets/`);
  }

  getFeeWidget() {
    return this.httpClient.get('/dashboard/get_feewidget/');
  }

  getGuagegraphWidget() {
    return this.httpClient.get('/dashboard/get_guagegraphwidget/');
  }

  // END

  getFullCalendarEvents() {
    return this.httpClient.get('/dashboard/get_fullcalendarevents/');
  }

  getUserBirthdays() {
    return this.httpClient.get('/dashboard/usersbirthdays/');
  }

  getReportWidgets() {
    return this.httpClient.get('/reports/reportwidgets/');
  }

  getTermwiseTopStudents() {
    return this.httpClient.get('/reports/termwise_topstudents/');
  }


  getStudentsMultiSelect(term) {
    return this.httpClient.get('/dashboard/querystudentsbyterm/', {params: {'term': term}});
  }

  loadStudents() {
    // load student in parent add page: Multiple Select
    // load student in parent filter by student: Single Select
    this.students$ = concat(
      of([]), // default items
      this.studentsinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(term => this.getStudentsMultiSelect(term).pipe(
          catchError(() => of([])), // empty list on error
        ))
      )
    );
  }

  getStudentAppreciation(){
    return this.httpClient.get('/exammanagement/appreciation/');    
  }

  ManageTeacherWidget(param){
    return this.httpClient.get("/dashboard/teacher_widget_manage/",{params:param})
  }

  ManageParentWidget(param){
    return this.httpClient.get("/dashboard/parent_widget_manage/",{params:param})
  }

  getParentStudentTransportation(){
    return this.httpClient.get("/transportation/get_parent_student_transportation/")
  }

  //pages
  getactiveslugs(){
    return this.httpClient.get('/dashboard/get_pages/');    
  }

  getactivepagefromslug(id){
    return this.httpClient.get('/dashboard/get_pages/',{params:{'slug':id}});    
  }

  Postnewpage(data){
    return this.httpClient.post('/dashboard/add_pages/', data);
  }


  getChequeInfoView(param){
    return this.httpClient.get('/feesnew/cheque_info_views/', {params:param});
  }
}

